(function () {
  const projectFilters = document.querySelectorAll(".single-project-filter");
  const toggleFilters = document.querySelectorAll(".filter-headline");

  for (let i = 0; i < projectFilters.length; i++) {
    projectFilters[i].addEventListener("click", function (event) {
      const filters = document.querySelectorAll(".single-project-filter");

      for (let i = 0; i < filters.length; i++) {
        filters[i].classList.remove("single-project-filter-active");
      }

      event.target.classList.toggle("single-project-filter-active");

      filterProjects();
    });
  }

  for (let f = 0; f < toggleFilters.length; f++) {
    toggleFilters[f].addEventListener("click", function (event) {
      let filters = toggleFilters[f].parentNode.querySelectorAll(
        ".single-project-filter"
      );

      for (let fl = 0; fl < filters.length; fl++) {
        filters[fl].classList.toggle("shown");
      }
    });
  }

  function filterProjects() {
    const filters = document.querySelectorAll(".single-project-filter-active");

    let currentFilters = [];

    for (let i = 0; i < filters.length; i++) {
      if (filters[i].dataset.catid != "all") {
        currentFilters.push(filters[i].dataset.catid);
      }
    }

    jQuery.ajax({
      type: "POST",
      url: globalvars.ajaxurl,
      data: {
        action: "filterprojects_ajaxhandler",
        nonce: globalvars.ajax_nonce,
        filters: currentFilters,
      },
      beforeSend: function () {
        document.getElementById("project-overview").classList.add("loading");
      },
      complete: function () {},
      success: function (data) {
        document.getElementById("project-overview").classList.remove("loading");
        document.getElementById("project-overview").innerHTML =
          JSON.parse(data);
      },
      error: function (MLHttpRequest, textStatus, errorThrown) {
        alert(textStatus, errorThrown);
      },
    });
  }
})();
